import useWaitingMutation from '@hooks/useWaitingMutation';
import { validateSubmission } from '@common/services/submissionService';
import { ErrorLog } from '@common/types';

export const useValidateSubmission = () => {
  const { mutate } = useWaitingMutation<ErrorLog[]>((submissionId: string) => validateSubmission(submissionId));

  return { validateSubmission: mutate };
};
